<template>
  <svg
    id="contour_copia"
    data-name="contour copia"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 64 64"
  >
    <title>71_message-LIGHT</title>
    <path
    fill="#679940"
      class="cls-1"
      d="M60,7H4a4,4,0,0,0-4,4V53a4,4,0,0,0,4,4H60a4,4,0,0,0,4-4V11A4,4,0,0,0,60,7Zm-2.65,4L35.8,25.12a6.94,6.94,0,0,1-7.6,0L6.65,11ZM4,53V14.05L26,28.46a10.92,10.92,0,0,0,12,0L60,14.05V53Z"
    />
  </svg>
</template>

<script>
export default {
  name: "MessageIcon"
};
</script>


// WEBPACK FOOTER //
// src/icons/MessageIcon.vue